<div *ngIf="order" class="content-area">
  <h3 class="content-title">Booking Details</h3>
  
  <div class="booking-details-card">
    <div class="booking-details-content">
      <div class="customer-name">{{ order.customerName }}</div>
      <div class="booking-info-grid">
        <!-- First Row -->
        <div class="info-row-container">
          <div class="info-column">
            <span class="info-label">PHONE NUMBER</span>
            <span class="info-value">{{ formatPhoneNumber(order.phone) }}</span>
          </div>
          <div class="info-column">
            <span class="info-label">EMAIL</span>
            <span class="info-value">{{ order.email }}</span>
          </div>
        </div>
        
        <!-- Second Row -->
        <div class="info-row-container">
          <div class="info-column">
            <span class="info-label">LOCATION</span>
            <span class="info-value">{{ order.branch || 'N/A' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
